import React from "react";
import AnimationHelper from "../../Helpers/AnimationHelper";

const UnderConstructionComp = () => {
  return (
    <section className="banner-area bg-white">
      <div className="contianer-fluid">
        <div className="d-flex justify-content-center align-items-center">
          <img
            className="img-fluid"
            src={AnimationHelper.underConstruction}
            alt="under construction"
          />
        </div>
      </div>
    </section>
  );
};

export default UnderConstructionComp;
